import { render } from "./BaseActions.vue?vue&type=template&id=5e470e75&scoped=true"
import script from "./BaseActions.vue?vue&type=script&lang=js"
export * from "./BaseActions.vue?vue&type=script&lang=js"

import "./BaseActions.vue?vue&type=style&index=0&id=5e470e75&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e470e75"]])

export default __exports__